import { render, staticRenderFns } from "./DomainsSelector.vue?vue&type=template&id=afbb6c12"
import script from "./DomainsSelector.vue?vue&type=script&lang=js"
export * from "./DomainsSelector.vue?vue&type=script&lang=js"
import style0 from "./DomainsSelector.vue?vue&type=style&index=0&id=afbb6c12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports